import PropTypes from 'prop-types';
import {PROJECT_STATUS, status} from './constant';

export const interventionPropTypes = () => PropTypes.shape({
  status: PropTypes.oneOf(Object.values(status)).isRequired,
  organisation: PropTypes.object.isRequired,
  endDate: PropTypes.string,
  project: PropTypes.shape({
    projectStatus: PropTypes.oneOf(Object.values(PROJECT_STATUS)).isRequired
  }).isRequired
});

export const planPropTypes = () => PropTypes.shape({
  externalId: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    translatedLabel: PropTypes.string.isRequired
  })),
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired,
    quantity: PropTypes.number,
    price: PropTypes.number
  })),
  setupFee: PropTypes.number,
  maxEmployees: PropTypes.number,
  maxDepositorOrganisations: PropTypes.number,
  recommended: PropTypes.bool
});
